const TPL_OPEN = "<!--";
const TPL_CLOSE = "-->";
const VAR_OPEN = "##|----";
const VAR_CLOSE= "##|----";
const TPL_NAME_CHARSET = "a-zA-Z0-9_\\-";
const INCLUDE_PREFIX = "incl_";
const IF_PREFIX = "if";
const UNLESS_PREFIX = "unless";

const TPL_REGEXP = new RegExp(TPL_OPEN + "\\s*([" + TPL_NAME_CHARSET + "]+)\\s*" + TPL_CLOSE + "((?:.|\n)*?)" + TPL_OPEN + "\\s*\\/\\1\\s*" + TPL_CLOSE, "g");
const INCLUDE_REGEXP = new RegExp("^" + INCLUDE_PREFIX + "([" + TPL_NAME_CHARSET + "]+)$");
const IF_REGEXP = new RegExp("^" + IF_PREFIX + "\\s*\\(([^)]+)\\)\\s*([" + TPL_NAME_CHARSET + "]+)$");
const UNLESS_REGEXP = new RegExp("^" + UNLESS_PREFIX + "\\s*\\(([^)]+)\\)\\s*([" + TPL_NAME_CHARSET + "]+)$");
const VAR_REGEXP = new RegExp("(?:" + VAR_OPEN + ")(.+?)(?:" + VAR_CLOSE + ")", "g");

function noUndefined(data) {
  return typeof data !== 'undefined' ? data: '';
}

function nestedProp(obj, path) {
  for (let i = 0; i < path.length; i++) obj = obj[path[i]];
  return obj;
}

export default class Template {
  constructor() {
    this.templates = {};
    this.varNames = [];
  }

  addTemplate(tplName, tplString) {
    // TODO: optimize (regex var matching slowed everything down)
    if(this.templates.hasOwnProperty(tplName)) console.warn("Template: overriding the template " + tplName);

    tplString = tplString.replace(TPL_REGEXP, (match, tplName, tplString) => {
      this.addTemplate(tplName, tplString);
      return '';
    });

    const tplArray = [];
    let matches;
    let lastEndIndex = 0;

    VAR_REGEXP.lastIndex = 0;

    while((matches = VAR_REGEXP.exec(tplString))) {
      const varName = matches[1];

      this.varNames.push(tplName + "/" + varName);

      tplArray.push({ type: "string", data: tplString.substring(lastEndIndex, matches.index)});

      let match;

      if((match = IF_REGEXP.exec(varName))) {
        tplArray.push({ type: "if", data: { var: match[1], tpl: match[2] } });
      } else if((match = UNLESS_REGEXP.exec(varName))) {
        tplArray.push({ type: "unless", data: { var: match[1], tpl: match[2] } });
      } else if((match = INCLUDE_REGEXP.exec(varName))) {
        tplArray.push({ type: "include", data: match[1] });
      } else {
        if (varName.indexOf(".") >= 1) {
          tplArray.push({type: "prop", data: varName.split(".")});
        } else {
          tplArray.push({type: "var", data: varName});
        }
      }

      lastEndIndex = matches.index + matches[0].length;
    }

    tplArray.push({ type: "string", data: tplString.substring(lastEndIndex) });

    this.templates[tplName] = tplArray;
  }

  parse(tplName, data) {
    const tplArray = this.templates[tplName];

    if (!tplArray) {
      throw new Error(`Template: ${tplName} not found.`);
    }

    let out = "";

    for(let i = 0; i < tplArray.length; i++) {
      const item = tplArray[i];
      let value;
      switch(item.type) {
        case "string":
          out += item.data;
          break;

        case "var":
          out += noUndefined(data[item.data]);
          break;

        case "prop":
          out += noUndefined(nestedProp(data, item.data));
          break;

        case "include":
          out += this.parse(item.data, data);
          break;

        case "if":
        case "unless":
          value = data[item.data.var];
          if(!!value === (item.type === "if")) {
            out += this.parse(item.data.tpl, Object.assign({}, data, { value }));
          }
          break;
      }
    }

    return out;
  }
};
